<script lang="ts" setup>
import '@vuepic/vue-datepicker/dist/main.css'
import { CustomEip1193Provider } from '@shared/utils'
import { Status, StatusType } from '@injectivelabs/utils'
import * as WalletTracker from '@/app/providers/mixpanel/WalletTracker'
import { Modal, StatusKey } from '@/types'

const route = useRoute()
const appStore = useAppStore()
const modalStore = useSharedModalStore()
const sharedTokenStore = useSharedTokenStore()
const sharedWalletStore = useSharedWalletStore()
const { $onError } = useNuxtApp()
const { provideStatuses } = useStatusMap()

onMounted(() => {
  if (route.query.automation === 'true') {
    ;(window as any).ethereum = new CustomEip1193Provider()
  }

  provideStatuses(
    Object.values(StatusKey).reduce(
      (list, key) => ({
        ...list,
        [key]: reactive(
          new Status(
            key === StatusKey.ProposalSubmitStatus
              ? StatusType.Idle
              : StatusType.Loading
          )
        )
      }),
      {}
    )
  )

  sharedTokenStore.fetchSupply()

  Promise.all([sharedWalletStore.init()])
    .catch($onError)
    .finally(() => {
      if (sharedWalletStore.isUserConnected) {
        WalletTracker.trackWalletAddress(sharedWalletStore.injectiveAddress)
      }
    })

  if (appStore.devMode) {
    modalStore.openModal(Modal.DevMode)
  }
})
</script>

<template>
  <UApp>
    <div class="min-h-screen">
      <NuxtLayout>
        <NuxtPage
          :transition="{
            mode: 'out-in',
            enterActiveClass: 'transition-all duration-300',
            leaveActiveClass: 'transition-all duration-300',
            leaveToClass: 'opacity-0 translate-y-2 scale-[0.98] blur',
            enterFromClass: 'opacity-0 translate-y-2 scale-[0.98] blur'
          }"
        />
      </NuxtLayout>
      <PartialsModalsDevMode />
    </div>
  </UApp>
</template>
